import React, { Component } from "react";
import { connect } from "react-redux";
import { ExcelRenderer } from "react-excel-renderer";
import ReactToExcel from "react-html-table-to-excel";
import BacktestService from "../../../../service/backtest.service";
import UploadFileButton from "../../../common/buttons/uploadFileButton";
import TreeTable from "../treeTable";
import TableErrorMessage from "../../../common/errorBoundary/tableErrorMessage";
// import CheckBox from "../../../common/checkbox";
import "./myUniverse.styles.scss";

class MyUniverse extends Component {
  state = {
    data: [],
    uploadError: false,
    uploadErrorMsg: null,
    tableSumErrorMsg:
      "Allocations are not adding up to 100%, Please fix and re-upload.",
    saveMessage: false,
    postingDatafailed: false,
    loading: false,
    spinner: false,
  };

  async componentWillMount() {
    this.props.setIQCIOliveMyUniverse([]);
    this.props.resetCurrentActiveStep(0);
    this.setState({
      loading: true,
    });
    await BacktestService.getMyUniverse()
      .then((res) => {
        if (res) {
          this.setState({
            data: res,
            loading: false,
          });
          this.props.setIQCIOliveMyUniverse(res);
        }
      })
      .catch((err) =>
        this.setState({
          loading: false,
        })
      );
  }
  xlsxHandler = (e) => {
    let file = e.target.files[0];
    if (file) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          this.setState({
            uploadError: false,
            uploadErrorMsg: null,
          });
          const { setIQCIOliveMyUniverse } = this.props;
          setIQCIOliveMyUniverse([]);

          //remove empty arrays
          var response = res["rows"].filter(
            (d) => d.length && d[0] && d[1] && d[2] && d[3] && d[4] && d[5]
          );

          if (response.length === 0) return;

          var heading = response[0].map((e) => e.toLowerCase().trim());
          // remove heading
          var data = response.slice(1, response.length);
          const getIndex = (string) => {
            return heading.indexOf(string);
          };

          let security_index =
            getIndex("security name") == -1
              ? getIndex("security")
              : getIndex("security name");
          let symbol_index = getIndex("symbol");
          let fund_type_index = getIndex("fund type");
          let classification_index = getIndex("classification");
          let asset_class_index = getIndex("asset class");
          let style_index = getIndex("style");
          // let core_allocation_index = getIndex("core allocation");
          let allocation_index = getIndex("allocation");

          // getting which column has error
          const getStatus = () => {
            if (security_index === -1) {
              setValue("security");
              return;
            } else if (symbol_index === -1) {
              setValue("symbol");
              return;
            } else if (fund_type_index === -1) {
              setValue("fund type");
              return;
            } else if (classification_index === -1) {
              setValue("classification");
              return;
            } else if (asset_class_index === -1) {
              setValue("asset class");
              return;
            } else if (style_index === -1) {
              setValue("style");
              return;
            }
            // else if (allocation_index == -1) {
            //   setValue("allocation");
            //   return;
            // }
          };
          const setValue = (name) => {
            this.setState({
              uploadError: true,
              uploadErrorMsg: `${name.toUpperCase()} column missing. Please make sure "${name}" column exists in the uploaded holdings excel.`,
            });
          };
          getStatus();

          let condition =
            heading.length > 0 &&
            data.length > 0 &&
            (heading[security_index] === "security name" ||
              heading[security_index] === "security" ||
              security_index !== -1) &&
            (heading[symbol_index] === "symbol" || symbol_index !== -1) &&
            (heading[fund_type_index] === "fund type" ||
              fund_type_index !== -1) &&
            (heading[classification_index] === "classification" ||
              classification_index !== -1) &&
            (heading[asset_class_index] === "asset class" ||
              asset_class_index !== -1) &&
            (heading[style_index] === "style" || style_index !== -1);
          // (heading[allocation_index] == "allocation" ||
          //   allocation_index !== -1);

          if (condition) {
            let arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj.fund_name = data[i][security_index];
              obj.symbol = data[i][symbol_index];
              obj.fund_type = data[i][fund_type_index];
              obj.classification = data[i][classification_index];
              obj.asset_class = data[i][asset_class_index];
              obj.style = data[i][style_index];
              obj.val = data[i][allocation_index]
                ? data[i][allocation_index]
                : null;

              arr.push(obj);
            }
            //  setting default cash row
            let cashFind = arr.filter(
              (d) => d.fund_name.toLowerCase() === "cash"
            );

            if (cashFind.length === 0) {
              let obj = {
                fund_name: "Cash",
                symbol: "IQCASH",
                fund_type: "Cash",
                classification: "Cash",
                asset_class: "Cash",
                style: "Cash",
                val: 0,
              };
              let ar = [obj, ...arr];
              setIQCIOliveMyUniverse(ar);
              this.setState({
                data: ar,
              });
            } else {
              setIQCIOliveMyUniverse(arr);
              this.setState({
                data: arr,
              });
            }
            document.getElementById("upload_iqcio_mymodels").value = "";
          } else {
            setIQCIOliveMyUniverse([]);
            console.log("my universe upload error");
            document.getElementById("upload_iqcio_mymodels").value = "";
            this.setState({
              data: [],
              uploadError: true,
            });
          }
        }
      });
    }
  };

  // checkBoxHandler = () => {
  //   const { overRideAllocation, overRideAllocationHandler } = this.props;
  //   overRideAllocationHandler(!overRideAllocation);
  // };

  saveButtonHandler = () => {
    const {
      myUniverse,
      // overRideAllocation,
    } = this.props;
    this.setState({
      postingDatafailed: false,
      spinner: true,
    });

    // let data_objects = { ...myUniverse };
    // posting data to backend
    BacktestService.postMyUniverse({
      securities: JSON.stringify(myUniverse),
      // allocation_override: overRideAllocation,
    })
      .then((res) => {
        console.log(res);
        this.setState({
          postingDatafailed: false,
          saveMessage: true,
          spinner: false,
        });
      })
      .catch((error) => {
        console.log(error, "error message");
        this.setState({
          postingDatafailed: true,
          saveMessage: false,
          spinner: false,
        });
      });

    setTimeout(
      () =>
        this.setState({
          saveMessage: false,
        }),
      5000
    );
    // setIQCIOliveMyUniverse(data);
  };
  render() {
    const {
      tableSumErrorMsg,
      uploadErrorMsg,
      uploadError,
      saveMessage,
      postingDatafailed,
      loading,
      spinner,
    } = this.state;
    const {
      myUniverse_allocation_sumError,
      setIQCIOliveMyUniverse,
      myUniverse,
    } = this.props;
    const errorMessageList = [];

    if (uploadError) {
      errorMessageList.push(uploadErrorMsg);
    }
    if (myUniverse_allocation_sumError) {
      errorMessageList.push(tableSumErrorMsg);
    }
    return (
      <div className="page-content">
        <div className="head-section">
          <h1 className="text-uppercase">
            My Security Universe & Default Core Allocations
          </h1>
        </div>
        <div className="page-body">
          <div className="step clearfix">
            <div className="iqcio_universe">
              <div className="iqcio_universe_contentOne">
                <div>
                  Please upload an excel sheet of your universe. You can also
                  add the security one by one via <b>ADD ROW</b> button below.
                </div>
                <div className="iqcio_universe_contentOne_btnGroup">
                  <ReactToExcel
                    table="universe_table_download"
                    filename="myUniverse_template"
                    sheet="security"
                    buttonText=" 📄 Download securities"
                    className="btn iq-btn1"
                  />
                  <UploadFileButton
                    id="upload_iqcio_mymodels"
                    icon="fa-upload"
                    iconRight={false}
                    text="Upload Securities"
                    eventHandler={(e) => this.xlsxHandler(e)}
                  />
                </div>
              </div>
              {/* <div className="iqcio_universe_contentTwo">
                Override user's allocation for a security with my universe
                allocation when customizing portfolios{" "}
                <CheckBox
                  status={this.props.overRideAllocation}
                  handler={() => this.checkBoxHandler()}
                />
              </div> */}
              {myUniverse_allocation_sumError || uploadError ? (
                <TableErrorMessage list={errorMessageList} />
              ) : null}

              <TreeTable
                setIQCIOliveMyUniverse={setIQCIOliveMyUniverse}
                data={myUniverse}
                saveButtonHandler={this.saveButtonHandler}
                saveMessage={saveMessage}
                postingDatafailed={postingDatafailed}
                loading={loading}
                spinner={spinner}
              />
              {myUniverse.length > 0 ? (
                <table
                  id="universe_table_download"
                  className="iqcio_universe__downloadTable"
                >
                  <thead>
                    <tr>
                      <th>Security</th>
                      <th>Symbol</th>
                      <th>Fund Type</th>
                      <th>Classification</th>
                      <th>Asset Class</th>
                      <th>Style</th>
                      <th>Allocation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myUniverse.map((obj, index) => {
                      return (
                        <tr key={`${obj.symbol}_${index}`}>
                          <td>{obj.fund_name}</td>
                          <td>{obj.symbol}</td>
                          <td>
                            {obj.new_fund_type
                              ? obj.new_fund_type
                              : obj.fund_type
                              ? obj.fund_type
                              : null}
                          </td>
                          <td>
                            {obj.new_classification
                              ? obj.new_classification
                              : obj.classification
                              ? obj.classification
                              : null}
                          </td>
                          <td>
                            {obj.fund_asset_class_focus
                              ? obj.fund_asset_class_focus
                              : obj.asset_class
                              ? obj.asset_class
                              : null}
                          </td>
                          <td>
                            {obj.new_style
                              ? obj.new_style
                              : obj.style
                              ? obj.style
                              : null}
                          </td>
                          <td>{obj.val}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setIQCIOliveMyUniverse: (payload) =>
    dispatch({
      type: "SET_IQCIO_LIVE_MY_UNIVERSE",
      payload,
    }),
  // overRideAllocationHandler: (payload) =>
  //   dispatch({
  //     type: "SET_IQCIO_LIVE_TOGGLE",
  //     payload,
  //   }),
  resetCurrentActiveStep: (value) =>
    dispatch({ type: "SET_ACTIVE_STEP_COUNT", payload: value }),
});
export default connect(
  ({
    iqciolive: {
      myUniverse_allocation_sumError,
      // overRideAllocation,
      myUniverse,
    },
  }) => ({
    myUniverse_allocation_sumError,
    // overRideAllocation,
    myUniverse,
  }),
  mapDispatchToProps
)(MyUniverse);



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/universe/myUniverse.jsx